module.exports = __webpack_public_path__ + "static/media/logo.0181037e.png";